import React from 'react'
import { ActionButton, Button } from '@enamelai/design-system'
import { Icon as DeleteIcon } from '@enamelai/design-system/icons/Delete2'
import { type AccountSummaryPaymentMethodItem } from '@assets/mockdata/PatientTray/mockAccountSummary'
import PatientProfileAccountBadge from './PatientProfileAccountBadge.component'

export function AccountDeleteButton({
  label,
  onClick,
}: {
  label: string
  onClick: () => void
}): React.ReactElement {
  return (
    <ActionButton
      className="patient-profile-account-delete"
      icon={<DeleteIcon aria-hidden="true" />}
      label={label}
      tone="danger"
      variant="outline"
      size="md"
      onClick={onClick}
    />
  )
}

export function AccountSetDefaultButton({
  label,
  onClick,
  disabled,
}: {
  label: string
  onClick: () => void
  disabled?: boolean
}): React.ReactElement {
  return (
    <Button
      variant="tertiary"
      size="xs"
      className="patient-profile-account-set-default"
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
    >
      Set default
    </Button>
  )
}

type PatientProfilePaymentMethodItemCardProps = {
  item: AccountSummaryPaymentMethodItem
  onDelete: () => void
  onSetDefault: () => void
  setDefaultDisabled?: boolean
  readOnly?: boolean
}

function PatientProfilePaymentMethodItemCard({
  item,
  onDelete,
  onSetDefault,
  setDefaultDisabled,
  readOnly = false,
}: PatientProfilePaymentMethodItemCardProps): React.ReactElement {
  const title = `Account ending:  ${item.lastFour}`

  return (
    <article className="patient-profile-account-item">
      <div className="patient-profile-account-item-head">
        <h4 className="patient-profile-account-item-title">{title}</h4>
        {item.badge === 'default' ? (
          <PatientProfileAccountBadge isDefault />
        ) : (
          <AccountSetDefaultButton
            label={`Set account ending in ${item.lastFour} as default`}
            onClick={onSetDefault}
            disabled={readOnly || setDefaultDisabled}
          />
        )}
      </div>
      <div
        className={`patient-profile-account-item-field${
          readOnly ? '' : ' patient-profile-account-item-field--with-action'
        }`}
      >
        <div className="patient-profile-account-item-field-main">
          <span className="patient-profile-account-item-field-label">
            Bank:
          </span>
          <span className="patient-profile-account-item-field-value patient-profile-account-item-field-value--regular">
            {item.bankName}
          </span>
        </div>
        {!readOnly ? (
          <AccountDeleteButton
            label={`Remove account ending in ${item.lastFour}`}
            onClick={onDelete}
          />
        ) : null}
      </div>
    </article>
  )
}

export default PatientProfilePaymentMethodItemCard
